import React from 'react';
import { PokerChip } from './PokerChip';
import { PokerChipValue } from './PokerChipValue';
import styles from './PokerChipStack.module.css';

interface ChipStackProps {
  chips: PokerChipValue[];
}

export const PokerChipStack: React.FC<ChipStackProps> = ({ chips }) => {
  const count = chips.length;

  return (
    <div
      className={styles.stackContainer}
      style={
        {
          '--chip-count': count,
        } as React.CSSProperties
      }
    >
      {chips.map((chipValue, index) => (
        <div
          key={index}
          className={styles.chipWrapper}
          style={{
            zIndex: index + 1,
            bottom: `calc(${index} * var(--chip-stack-offset))`,
          }}
        >
          <PokerChip value={chipValue} />
        </div>
      ))}
    </div>
  );
};

export default PokerChipStack;
